"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVA_SCRIPT = exports.AVA_POSITION_DEFAULTS = exports.AVA_DEFAULTS = void 0;
var AVA_SCRIPT = {
  ID: '__ada',
  SOURCE: 'https://static.ada.support/embed.js',
  SOURCE2: 'https://static.ada.support/embed2.js'
};
exports.AVA_SCRIPT = AVA_SCRIPT;
var AVA_POSITION_DEFAULTS = {
  TOP: 'auto',
  RIGHT: '50px',
  BOTTOM: '40px',
  LEFT: 'auto'
};
exports.AVA_POSITION_DEFAULTS = AVA_POSITION_DEFAULTS;
var IMAGE_CONFIG_DEFAULTS = {
  IMAGEURL: 'https://a.staticaa.com/images/misc/ava-blurb.png',
  WIDTH: '46px',
  HEIGHT: '46px',
  RADIUS: '50%'
};
var AVA_DEFAULTS = {
  IMAGE_CONFIG: IMAGE_CONFIG_DEFAULTS,
  DATA_CONFIG: {
    TOOLTIP_LABEL: 'Chat with AVA',
    STAGING_ID: 'airasia-sandbox',
    PRODUCTION_ID: 'airasia'
  },
  ENV: 'prod',
  LANG: 'en-gb',
  URLS: {
    GCS: {
      HOMEPAGE_MAIN: 'homepage/main/',
      PROD: 'https://sch.apiairasia.com/',
      OTHERS: 'https://ppsch.apiairasia.com/'
    },
    SSO: {
      PROD: 'https://ssor.airasia.com/',
      OTHERS: 'https://stgsso-apigw.airasia.com/'
    },
    ENCRYPTION_URL: 'https://k.apiairasia.com/EncyptData',
    BY_ORIGIN: 'config/v2/clients/by-origin'
  },
  API_KEY: 'apiKey',
  CLIENT_ID_KEY: 'clientId',
  ADA: {
    PARENT_ELEMENT: 'Avaembed',
    METAFIELDS: {
      PLATFORM: 'WEB',
      SOURCE: 'HOMEPAGE'
    }
  },
  IS_AVA_OPEN: 'isAvaOpen'
};
exports.AVA_DEFAULTS = AVA_DEFAULTS;